import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice: (state) => state.api.server.reboot,
	actionType: 'SERVER_REBOOT',
	method: 'POST',
	url: '/server/power/reboot.json',
});

export { actions, reducer, sagas, selectors };
